import RecoverPassword from "@/views/admin/user/RecoverPassword";

export default {
  path: "/recover-password",
  name: "RecoverPassword",
  component: RecoverPassword
};
